import { Component, OnInit, Inject } from '@angular/core';
import { GetLettersModel } from '@app/base/shared/models/letter.model';
import { SessionService, LookupsService, ConstantsService, EnvironmentService, AccountService } from '@app/core/services';
import { BuilderService } from '../../base';
import { SocoHttpService } from '@app/soco/http';
import { takeWhile } from 'rxjs/operators';
import { AlertService } from '@app/base/alerts/alert.service';
import { NavigationEnd, Router, ActivatedRoute } from '@angular/router';


declare var swal: any;
@Component({
  selector: 'app-letter-summery',
  templateUrl: './letter-summery.component.html',
  styleUrls: ['./letter-summery.component.css']
})
export class LetterSummeryComponent implements OnInit {
    // Searching
    queryString: any;
    // pagination
    p = 1;
    LetterList: GetLettersModel[] = [];
    LetterName: string[] = [];
    obj: GetLettersModel;
    LtList: string[];
    LetterId: string[];
    public builderdata: any = {};
    state: string;
    streetname: string;
    builderMapping = [];
    city: string;
    userName: string;
    killsubscribe: boolean;
    cityValues = [];
    stateValues = [];
    alertMsg: any = [];
    updateFlag;
    projectNumber: any;
    componentname : string | null='';
    constructor(
        private session: SessionService,
        @Inject(Router) private router: Router,
        private builderSvc: BuilderService,
        private lookupSvc: LookupsService,
        public accountSvc: AccountService,
        private socoHttp: SocoHttpService, private alertService: AlertService,
        public environmentSvc: EnvironmentService,
        public constantsService: ConstantsService,
        private route: ActivatedRoute) {

    }

    ngOnInit() {
        const subscribe = this.lookupSvc.commonLookupsLoaded$.subscribe(val => {
            if (subscribe && val) {
                subscribe.unsubscribe();
            }
            if (val) {
                this.alertMsg = (this.lookupSvc.bannerMessages.find(x => x.itemName === 'Builder Gas Letter'
                ));
                this.alertService.info(this.alertMsg.message);
                this.cityValues = this.lookupSvc.cities;
                this.stateValues = this.lookupSvc.states;
            }
        });

        // Accessing route parameters
        this.route.params.subscribe(params => {
            this.componentname = params['Gas-Availability-Letter-Summary'];
        });

        this.userName = this.accountSvc.account.user.username;
                this.LetterDetailsInfo();

            
      
    }


    navigateToAnother() {
        const path = ['/', this.session.paramLdc.toLowerCase(), 'builder', 'letter'];

        // Navigate to the constructed path
        this.router.navigate(path);
    }
    
    // code to fetch letter request details from DB
    letterData() {
        this.builderSvc.getletterInfo(this.userName).subscribe(result => {
           if (result.data !== null || result !== undefined) {
                    for (let i = 0; i < result.data.length; i++) {
                        this.obj = new GetLettersModel;
                        this.obj.Address = result.data[i].serviceFormattedAddress;
                        this.obj.Status = result.data[i].status.toLowerCase();
                        this.LetterList.push(this.obj);
                    }
                    this.socoHttp.hidePleaseWait('ContainerAwaiter');
                } else {
                    swal(this.constantsService.errorSwal1, this.constantsService.GetgasAvailabilityLetterSwal, this.constantsService.errorSwal);
                    this.socoHttp.hidePleaseWait('ContainerAwaiter');
                }
            
            });
        
    }

    LetterDetailsInfo() {
        
                this.socoHttp.showPleaseWait('Processing', 'ContainerAwaiter');
                this.letterData();
    
    }
       

    // To go to builder home page
    navigateHome() {
        this.session.GetBcaData(null);
        this.router.navigate([
            this.session.paramLdc.toLowerCase(),
            'builder',
            'home'
        ]);
    }
   
   
}
